import { wccModules } from 'enums/wccModules';
import { ImageHelpers } from 'helpers/images';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import FancyBoxExtender from '../../../../libraries/fancybox';
import AttachmentControlVM from './control';
import './imageExpand.html';

const minSize = 400;

export interface AttachmentImageExpandControlVMConfig {
    src?: SubscribableOrNullableValue<string>
    title?: SubscribableOrNullableValue<string>
    ignoreSize?: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class AttachmentImageExpandControlVM extends AttachmentControlVM {
    private src: Subscribable<string | undefined>
    private title: Subscribable<string | undefined>

    private hasValidImage: Subscribable<boolean>
    private isSizeIgnored: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: AttachmentImageExpandControlVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        super(info);

        this.src = ko.flattenComputed(config.src);
        this.title = ko.flattenComputed(config.title);

        this.isSizeIgnored = ko.flattenComputed(config.ignoreSize, false);

        this.hasValidImage = ko.fromPromise(async src => {
            if (src != undefined) {
                const image = await ImageHelpers.waitImage(ImageHelpers.getImage(src, true));

                return image.width > minSize || image.height > minSize;
            }
        }, [this.src], false);
    }

    click() {
        this.expand();
    }

    protected override checkIfVisible() {
        return super.checkIfVisible() && (this.isSizeIgnored() || this.hasValidImage());
    }

    private expand() {
        const src = this.src();
        const caption = this.title();

        if (src != undefined) {
            $.fancybox.open({
                src, opts: { caption }  // image options 
            },
            { // fancy box options
                onInit: function (instance) {
                    FancyBoxExtender.FixImgCors(instance); // fix our CORS issues
                }
            });            
        }
    }
}